import React, { useCallback, useState } from 'react';
import PopNotificationWithUndo from 'components/PopNotificationWithUndo';
import {
  ActiveSuggestedAction,
  SUGGESTED_ACTION_MUTE_DAYS,
} from 'router/subrouters/DataRoom/models/Dashboard';
import useUndoActions from 'hooks/useUndoActions';
import useGetPausedSuggestedAction from './useGetPausedSuggestedAction';
import { useTranslation } from 'react-i18next';

export type SuggestedActionUndoHandlers = {
  setSuggestion: (suggestion: ActiveSuggestedAction) => void;
  setDismissUndoTimeout: () => void;
  setDontRemindUndoTimeout: () => void;
};

const useGetUndoActions = () => {
  const [suggestion, setSuggestion] = useState<ActiveSuggestedAction>();

  const {
    isUndoAvailable: isDismissUndoAvailable,
    setUndoTimeout: setDismissUndoTimeout,
    clearUndoTimeout: clearDismissUndoTimeout,
  } = useUndoActions();

  const {
    isUndoAvailable: isDontRemindUndoAvailable,
    setUndoTimeout: setDontRemindUndoTimeout,
    clearUndoTimeout: clearDontRemindUndoTimeout,
  } = useUndoActions();

  const { isRestoring, onRestore } = useGetPausedSuggestedAction(suggestion);

  const onUndoActions = useCallback(() => {
    onRestore();
    clearDismissUndoTimeout();
    clearDontRemindUndoTimeout();
  }, [clearDismissUndoTimeout, clearDontRemindUndoTimeout, onRestore]);

  const { t } = useTranslation();

  const undoNotifications = (
    <>
      <PopNotificationWithUndo
        isUndoAvailable={isDismissUndoAvailable}
        disabled={isRestoring}
        onUndo={onUndoActions}
      >
        <p>{t('actionDismissed', { count: SUGGESTED_ACTION_MUTE_DAYS })}</p>
      </PopNotificationWithUndo>
      <PopNotificationWithUndo
        isUndoAvailable={isDontRemindUndoAvailable}
        disabled={isRestoring}
        onUndo={onUndoActions}
      >
        <p>{t('youWontBeReminded')}</p>
      </PopNotificationWithUndo>
    </>
  );

  return {
    undoNotifications,
    setSuggestion,
    setDismissUndoTimeout,
    setDontRemindUndoTimeout,
  };
};

export default useGetUndoActions;
